import {
  createActionTypes,
  createAsyncActionTypes,
} from '../../util/createLifeomicActionTypes';

const asyncActions = createAsyncActionTypes([
  'FETCH_PROJECT_TAGS',
  'CREATE_PROJECT_TAG',
  'DELETE_PROJECT_TAG',
  'UPDATE_PROJECT_TAG',
] as const);

const syncActions = createActionTypes([
  'SET_PROJECT_TAGS',
  'SET_PROJECT_TAG',
  'UNSET_PROJECT_TAG',
] as const);

export default {
  ...asyncActions,
  ...syncActions,
};
